import {
  Archive,
  DownloadSquare,
  MinusCircle,
  PlusCircle,
  RefreshDouble,
} from "iconoir-react";
import { PageAction } from "shared/components/organisms/PageActions";
import i18n, { i18nNamespace, loadLanguagePacks } from "i18n";

await loadLanguagePacks([i18nNamespace.Core, i18nNamespace.CustomLists]);

export enum CustomListDetailsPageActionKey {
  AddToFavorites = "ADD_TO_FAVORITES",
  ExportToCsv = "EXPORT_TO_CSV",
  CreateFromList = "CREATE_FROM_LIST",
  ArchiveList = "ARCHIVE_LIST",
}

export const customListDetailsViewSections: PageAction[] = [
  {
    Icon: PlusCircle,
    key: CustomListDetailsPageActionKey.AddToFavorites,
    text: i18n.t("core:FAVORITES.CTA_BUTTON_COPY"),
    alternateInfo: {
      Icon: MinusCircle,
      text: i18n.t(`core:FAVORITES.CTA_BUTTON_COPY_ALTERNATE`),
    },
  },
  {
    Icon: DownloadSquare,
    key: CustomListDetailsPageActionKey.ExportToCsv,
    text: i18n.t(
      `customLists:LIST_DETAILS.ACTIONS.${CustomListDetailsPageActionKey.ExportToCsv}`,
    ),
  },
  /* Currently not available
  {
    Icon: GridPlus,
    key: CustomListDetailsPageActionKey.CreateFromList,
    text: i18n.t(
      `customLists:LIST_DETAILS.ACTIONS.${CustomListDetailsPageActionKey.CreateFromList}`,
    ),
  }, */
  {
    Icon: Archive,
    key: CustomListDetailsPageActionKey.ArchiveList,
    text: i18n.t("core:ARCHIVE.CTA_BUTTON_COPY", {
      entityType: i18n.t("core:ARCHIVE.TYPE.LIST"),
    }),
    alternateInfo: {
      Icon: RefreshDouble,
      text: i18n.t("core:ARCHIVE.CTA_BUTTON_COPY_ALTERNATE", {
        entityType: i18n.t("core:ARCHIVE.TYPE.LIST"),
      }),
    },
  },
];
